const imageFormats = ["jpg", "jpeg", "svg", "png", "gif"];

const documentMimeTypes: Record<string, string> = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  pdf: "application/pdf",
  heic: "image/heic",
  heif: "image/heif",
};

export const getFileType = (imgLink: string): string | undefined => {
  if (!imgLink) {
    return undefined;
  } else return imgLink.split(".").pop();
};

export const isImage = (fileName: string): boolean => {
  const type = getFileType(fileName);

  return type ? imageFormats.includes(type) : false;
};

export const getDocumentMimeType = (fileName: string): string | undefined => {
  const extension = getFileType(fileName)?.toLowerCase();

  return extension ? documentMimeTypes[extension] : undefined;
};

export const previewIcon = (fileLink: string, fileName = ""): string => {
  const image = isImage(fileName || fileLink);

  return image ? fileLink : require(`@/assets/icons/icon-pdf.svg`);
};

export function getDocumentName(name: string) {
  const parts = name.split("/");

  return parts[parts.length - 1];
}
